export default __webpack_public_path__ + "static/banner-budget-cheat-sheet-54f5342252a1fa037f511d0e8b9f98bc.jpg";